var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-dark-light py-3 px-6 text-center text-text-secondary text-sm datav-border"},[_c('p',[_vm._v("© 2025 动环监控系统 | 版本号: v2.5.0")])])
}]

export { render, staticRenderFns }